var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneral04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.292 25.8753L24.792 30.3753L34.917 20.2503M45.042 27.0003C45.042 38.0443 32.9956 46.0767 28.6125 48.6338C28.1143 48.9244 27.8653 49.0697 27.5138 49.1451C27.241 49.2036 26.843 49.2036 26.5702 49.1451C26.2187 49.0697 25.9696 48.9244 25.4715 48.6338C21.0884 46.0767 9.04199 38.0443 9.04199 27.0003V16.2399C9.04199 14.441 9.04199 13.5416 9.3362 12.7684C9.59611 12.0854 10.0185 11.4759 10.5667 10.9928C11.1874 10.4458 12.0295 10.13 13.7139 9.49835L25.7779 4.97434C26.2457 4.79892 26.4796 4.71122 26.7202 4.67645C26.9336 4.64561 27.1504 4.64561 27.3638 4.67645C27.6044 4.71122 27.8383 4.79892 28.306 4.97434L40.3701 9.49835C42.0544 10.13 42.8966 10.4458 43.5173 10.9928C44.0655 11.4759 44.4879 12.0854 44.7478 12.7684C45.042 13.5416 45.042 14.441 45.042 16.2399V27.0003Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral04);
export default __webpack_public_path__ + "static/media/general04.498f1fdd79d9ba0ab3e59a617dd9bfa7.svg";
export { ForwardRef as ReactComponent };